import Repository from './Repository'

const action = 'contracts'
const approvementAction = 'approvements'

export default {
  addDocumentToContract(data) {
    return Repository.post(`${action}/${data.contract_id}/documents`, data)
  },
  signDocumentInContract(data) {
    return Repository.post(
      `${action}/${data.contract_id}/documents/${data.doc_id}`,
      { is_signed: data.is_signed },
    )
  },
  activeDocumentInContract(data) {
    return Repository.post(
      `${action}/${data.contract_id}/documents/${data.doc_id}/make-current`,
    )
  },
  deleteDocumentFromContract(data) {
    return Repository.delete(
      `${action}/${data.contract_id}/documents/${data.doc_id}`,
    )
  },
  getDocumentsInContract(contract_id) {
    return Repository.get(`${action}/${contract_id}/documents`)
  },
  getContractsList(id) {
    return Repository.get(`${action}?contragent_id=${id}`)
  },
  findContractsByInn(carriesInn, exporterOrgInn, params = '') {
    return Repository.get(
      action +
        '?carrier_org_inn=' +
        carriesInn +
        '&exporter_org_inn=' +
        exporterOrgInn +
        '&is_safe_otvechayu=1' +
        params,
    )
  },
  post(data) {
    return Repository.post(
      `${action}?expand=document,document.master-approve`,
      data,
    )
  },
  setApprovement(link_by_id = null, user_org_inn = null) {
    const link_by_rel = 'documents'
    const create_master_approve = 1
    const data = {
      link_by_id,
      user_org_inn,
      link_by_rel,
      create_master_approve,
    }

    return Repository.post(approvementAction, data)
  },
  delete(id) {
    return Repository.delete(`${action}/${id}`)
  },
  addTypeContract(data) {
    return Repository.put(`${action}/${data.id}`, {
      documents_workflow: data.documents_workflow,
    })
  },
  contractPrintTemplate(data, idTemplate = 22) {
    return Repository.post(
      '/template-files/fill',
      {
        template_file_id: idTemplate,
        tags: data,
      },
      { responseType: 'arraybuffer' },
    )
  },
  docNum(inn) {
    return Repository.get('/documents?contract_exporter_org_inn=' + inn)
  },
  get(id) {
    return Repository.get(action + '/' + id)
  },
  getList(settings) {
    let params = ''

    for (let key in settings) {
      if (Boolean(settings[key]) || settings[key] === 0) {
        params += params ? '&' : '?'
        params += `${key}=${settings[key]}`
      }
    }

    return Repository.get(`${action}${params}&expand=document,document.files`)
  },
}
